<template>
    <div class="create-preservation-info">
<!--        <MyTitle theTitle="保全信息" isSubmit="已提交"/>-->
        <ac-title-bar title="申请保全" @back="back"></ac-title-bar>

        <!-- 对接在线服务新增 start -->
        <van-popup v-if="showAddPerson" v-model="showAddPerson" position="bottom">
            <van-picker
                show-toolbar
                :columns="personList"
                :default-index="0"
                value-key="name"
                @cancel="showAddPerson = false"
                @confirm="confirmAddPerson">
            </van-picker>
        </van-popup>
        <!-- 对接在线服务新增 end -->

        <div class="fd-com-scroll" ref="element">
            <van-cell-group>
                <info-title title-content="保全基本信息" vertical-line="true">
                     <template slot="icon">
                        <van-icon
                                slot="right-icon"
                                name="arrow"
                                style="line-height: inherit; float: right"
                                @click="editBasic"
                        ></van-icon>
                    </template>
                </info-title>
                <div class="preservation-basic-info">
                    <div class="preservation-basic-info-inner">
                        <van-row>
                            <van-col span="9" class="col-key" align="right">申请法院</van-col>
                            <van-col span="13" class="col-value" offset="2">{{bqJbxx.cSqdyfymc}}</van-col>
                        </van-row>
                        <van-row>
                            <van-col span="9" class="col-key" align="right">保全类型</van-col>
                            <van-col span="13" class="col-value" offset="2">{{bqJbxx.cBqlx}}</van-col>
                        </van-row>
                        <van-row>
                            <van-col span="9" class="col-key" align="right">保全类别</van-col>
                            <van-col span="13" class="col-value" offset="2">{{bqJbxx.cBqlbText}}</van-col>
                        </van-row>
                        <van-row v-if="bqJbxx.cBqlb == 2">
                            <van-col span="9" class="col-key" align="right">案件类型</van-col>
                            <van-col span="13" class="col-value" offset="2">{{formData.nAjlx}}</van-col>
                        </van-row>
                        <van-row v-if="bqJbxx.cBqlb == 2">
                            <van-col span="9" class="col-key" align="right">诉讼案号</van-col>
                            <van-col span="13" class="col-value" offset="2" @click="toast(formData.cBqah)">
                                {{formData.cBqah}}
                            </van-col>
                        </van-row>
                        <van-row v-if="bqJbxx.cBqlb == 2 && (formData_1.nAjlx == 1 || formData_1.nAjlx == 2)">
                            <van-col span="9" class="col-key" align="right">案由</van-col>
                            <van-col span="13" class="col-value" offset="2" @click="toast(formData.cAy)">
                                {{formData.cAy}}
                            </van-col>
                        </van-row>
                        <van-row v-if="bqJbxx.cBqlb == 2 && formData_1.nAjlx == 6">
                            <van-col span="9" class="col-key" align="right">{{ayLabel_1}}</van-col>
                            <van-col span="13" class="col-value" offset="2" @click="toast(cAyzt)">
                                {{cAyzt}}
                            </van-col>
                        </van-row>
                        <van-row v-if="bqJbxx.cBqlb == 2 && formData_1.nAjlx == 6">
                            <van-col span="9" class="col-key" align="right">{{ayLabel_2}}</van-col>
                            <van-col span="13" class="col-value" offset="2" @click="toast(cAyxw)">
                                {{cAyxw}}
                            </van-col>
                        </van-row>
                        <van-row v-if="bqJbxx.cBqlb == 2 && formData_1.nAjlx == 6 && cAhNf >= 2021">
                            <van-col span="9" class="col-key" align="right">行政案由名称</van-col>
                            <van-col span="13" class="col-value" offset="2" @click="toast(cXzaymc)">
                                {{cXzaymc}}
                            </van-col>
                        </van-row>
                        <van-row
                                v-if="[1,4].includes(parseInt(bqJbxx.cBqlb))"
                        >
                            <van-col span="9" class="col-key" align="right">非诉期间</van-col>
                            <van-col span="13" class="col-value" offset="2" @click="toast(bqJbxx.cFsqj)">{{bqJbxx.cFsqj}}</van-col>
                        </van-row>
                        <van-row>
                            <van-col span="9" class="col-key" align="right">申请保全金额</van-col>
                            <van-col span="13" class="col-value" offset="2">{{bqJbxx.nSqbqje}}元</van-col>
                        </van-row>
                        <van-row>
                            <van-col span="9" class="col-key" align="right">建议保全费</van-col>
                            <van-col span="13" class="col-value" offset="2">{{bqJbxx.nSqbqdcsfy}}元</van-col>
                        </van-row>
                        <van-row>
                            <van-col span="9" class="col-key" align="right">担保情况</van-col>
                            <van-col span="13" class="col-value" offset="2">{{bqJbxx.cDbqkText}}</van-col>
                        </van-row>
                         <van-row v-if='bqJbxx.cDbqk == 3'>
                            <van-col span="9" class="col-key" align="right">无需担保原因</van-col>
                            <van-col span="13" class="col-value" offset="2" @click="toastWxdb(bqJbxx.nWdbyyText)">{{bqJbxx.nWdbyyText}}</van-col>
                        </van-row>
                        <van-row>
                            <van-col span="9" class="col-key" align="right">提交人</van-col>
                            <van-col span="13" class="col-value" offset="2">{{bqJbxx.cTjr}}</van-col>
                        </van-row>
                        <van-row>
                            <van-col span="9" class="col-key" align="right">提交人身份</van-col>
                            <van-col span="13" class="col-value" offset="2">{{bqJbxx.cTjrlx}}</van-col>
                        </van-row>
                        <van-row>
                            <van-col span="9" class="col-key" align="right">提交日期</van-col>
                            <van-col span="13" class="col-value" offset="2">{{bqJbxx.dtTjsj}}</van-col>
                        </van-row>
                    </div>
                </div>
                <info-title title-content="申请人" required-description="必填" vertical-line="true">
                    <template slot="icon">
  <van-icon
    slot="right-icon"
    name="plus"
    style="line-height: inherit; float: right"
    @click="clickAddSqr"
  ></van-icon>
</template>
                </info-title>
                <van-swipe-cell
                        v-for="(item, index) in bqSqrxxs"
                        :key="item.sqrid"
                >
                    <van-cell :title=item.sqrmc :value=item.sqrlx @click="editSQR(item)" is-link></van-cell>
                    <template slot="right">
  <div class="delete-btn" @click="deleteBqSQR(item.sqrid, index)">删除</div>
</template>
                </van-swipe-cell>
                <info-title title-content="被申请人" required-description="必填" vertical-line="true">
                    <template slot="icon">
  <van-icon
    slot="right-icon"
    name="plus"
    style="line-height: inherit; float: right"
    @click="clickAddBsqr"
  ></van-icon>
</template>
                </info-title>
                <van-swipe-cell
                        v-for="(item, index) in bqBsqrxxs"
                        :key="item.bsqrid"
                >
                    <van-cell :title=item.bsqrmc :value=item.bsqrlx @click="editBqBsqr(item)" is-link></van-cell>
                    <template slot="right">
  <div class="delete-btn" @click="deleteBqBSQR(item.bsqrid, index)">删除</div>
  <!-- <van-button square type="danger" text="删除" @click="deleteBqBSQR(item.bsqrid, index)"></van-button> -->
</template>
                </van-swipe-cell>
                <info-title title-content="原告代理人" vertical-line="true">
                    <template slot="icon">
  <van-icon
    slot="right-icon"
    name="plus"
    style="line-height: inherit; float: right"
    @click="clickAddYgdlr"
  ></van-icon>
</template>
                </info-title>
                <van-swipe-cell
                        v-for="(item, index) in bqDlrxxs"
                        :key="item.dlrid"
                >
                    <van-cell :title=item.dlrmc value="" @click="editBqYgdlr(item)" is-link></van-cell>
                    <template slot="right">
  <div class="delete-btn" @click="deleteBqYGDLR(item.dlrid, index)">删除</div>
</template>
                </van-swipe-cell>
                <!--财产线索-->
                <div v-if="bqJbxx.cBqlx=='财产保全'&&isXsShow == 1 && !bqCcckxxs.length">
                    <info-title title-content="财产线索" required-description="必填" vertical-line="true">
                        <template slot="icon">
                            <van-icon
                                    slot="right-icon"
                                    name="plus"
                                    style="line-height: inherit; float: right"
                                    @click="addBqCcxs"
                            ></van-icon>
                        </template>
                    </info-title>
                    <van-swipe-cell
                            v-for="(item, index) in bqCcxsxxs"
                            :key="item.ccxsid"
                    >
                        <van-cell
                                :title=item.ccxsmc
                                :value=item.ccxsjz
                                :key="item.ccxsid"
                                @click="goToAddBqCCXS(item.ccxsid)"
                                is-link
                        ></van-cell>
                        <template slot="right">
                            <div class="delete-btn" @click="deleteBqCCXS(item.ccxsid, index)">删除</div>
                        </template>
                    </van-swipe-cell>
                    <van-cell
                            :title=bqccxszjz
                            size="large"
                            style="text-align: right"
                    ></van-cell>
                </div>
                <!--证据信息-->
                <div v-if="bqJbxx.cBqlx=='证据保全' && isZjShow == 1">
                    <info-title title-content="证据信息" required-description="必填" vertical-line="true">
                        <template slot="icon">
                            <van-icon
                                slot="right-icon"
                                name="plus"
                                style="line-height: inherit; float: right"
                                @click="addBqZjxx"
                            ></van-icon>
                        </template>
                    </info-title>
                    <van-swipe-cell
                        v-for="(item, index) in bqZjxx"
                        :key="item.cId"
                    >
                        <van-cell
                            :title=item.nZjlx
                            :value=item.cZjmc
                            :key="item.cId"
                            @click="goToAddBqZjxx(item.cId)"
                            is-link
                        ></van-cell>
                        <template slot="right">
                            <div class="delete-btn" @click="deleteBqZjxx(item.cId, index)">删除</div>
                        </template>
                    </van-swipe-cell>
                </div>
                <!--行为信息-->
                <div v-if="bqJbxx.cBqlx=='行为保全' && isXwShow === 1">
                    <info-title title-content="行为信息" required-description="必填" vertical-line="true">
                        <template slot="icon">
                            <van-icon
                                slot="right-icon"
                                name="plus"
                                style="line-height: inherit; float: right"
                                @click="addBqXwxx"
                            ></van-icon>
                        </template>
                    </info-title>
                    <van-swipe-cell
                        v-for="(item, index) in bqXwxx"
                        :key="item.cId"
                    >
                        <van-cell
                            :title=item.nXwbqsx
                            :value=item.cSxsm
                            :key="item.cId"
                            @click="goToAddBqXwxx(item.cId)"
                            is-link
                        ></van-cell>
                        <template slot="right">
                            <div class="delete-btn" @click="deleteBqXwxx(item.cId, index)">删除</div>
                        </template>
                    </van-swipe-cell>
                </div>


                <!--诉前保全无财产查控-->
                <div class="fd-file-box" v-if="bqJbxx.cBqlx=='财产保全'&&isCkShow == 1 && !bqCcxsxxs.length">
                    <info-title title-content="财产查控" vertical-line="true">
                        <template slot="icon">
                            <van-icon
                                    slot="right-icon"
                                    name="plus"
                                    style="line-height: inherit; float: right"
                                    @click="addBqCcck()"
                            ></van-icon>
                        </template>
                    </info-title>
                </div>
                <info-title v-if="isShowDbxx" title-content="担保信息" required-description="必填" vertical-line="true">
                    <template slot="icon">
  <van-icon
    slot="right-icon"
    name="plus"
    style="line-height: inherit; float: right"
    @click="addBqDbxx"
  ></van-icon>
</template>
                </info-title>
                <van-swipe-cell
                        v-for="(item, index) in bqDbxxs"
                        :key="item.cId"
                >
                    <van-cell
                            :title=cDbwmc(item)
                            :value=item.nDbjz
                            :key="item.cId"
                            @click="goToEditBqDbxx(item.cId)"
                            is-link
                    ></van-cell>
                    <template slot="right">
  <div class="delete-btn" @click="deleteBqDbxx(item.cId, index)">删除</div>
</template>
                </van-swipe-cell>
                <van-cell
                        v-if="isShowDbxx"
                        :title=dbxxzjz
                        size="large"
                        style="text-align: right"
                ></van-cell>
                <info-title title-content="上传材料" vertical-line="true"/>
                <info-title title-content="保全申请书" required-description="必填"/>
                <van-uploader
                        name="1"
                        :before-read="beforeRead"
                        :after-read="fileUpload"
                        class="uploader"
                        v-model="sqs"
                        :max-count="5"
                        :before-delete="deleteCl"
                ></van-uploader>
                <div v-if="bqJbxx.cBqlb==='4'">
                    <info-title title-content="生效法律文书" required-description="必填"/>
                    <van-uploader
                        name="10"
                        :before-read="beforeRead"
                        :after-read="fileUpload"
                        class="uploader"
                        v-model="sxflws"
                        :max-count="5"
                        :before-delete="deleteCl"
                    ></van-uploader>
                </div>
                <!-- 财产保全时显示 立案受理通知书 起诉状 -->
                <div v-if="(bqJbxx.cBqlx=='财产保全'||bqJbxx.cBqlx=='行为保全' || bqJbxx.cBqlx=='证据保全')&&bqJbxx.cBqlb!=='4'">
                    <info-title title-content="起诉状" :required-description="bqJbxx.cBqlb == 2 ? '必填' : ''"/>
                    <van-uploader
                            name="2"
                            :before-read="beforeRead"
                            :after-read="fileUpload"
                            class="uploader"
                            v-model="qsz"
                            :max-count="5"
                            :before-delete="deleteCl"
                    ></van-uploader>
                    <info-title title-content="立案受理通知书" :required-description="bqJbxx.cBqlb == 1 ? '' : '必填'"/>
                    <van-uploader
                            name="6"
                            :before-read="beforeRead"
                            :after-read="fileUpload"
                            class="uploader"
                            v-model="lasltzs"
                            :max-count="5"
                            :before-delete="deleteCl"
                    ></van-uploader>
                </div>
                 <!-- 行为保全 & 证据保全 时显示 仲裁受理通知书 仲裁函 -->
                 <!--<div v-if="bqJbxx.cBqlx=='行为保全' || bqJbxx.cBqlx=='证据保全'">
                    <info-title title-content="仲裁受理通知书" required-description="必填"/>
                    <van-uploader
                            name="8"
                            :before-read="beforeRead"
                            :after-read="fileUpload"
                            class="uploader"
                            v-model="zcsltzs"
                            :max-count="5"
                            :before-delete="deleteCl"
                    ></van-uploader>
                    <info-title title-content="仲裁函" required-description="必填"/>
                    <van-uploader
                            name="9"
                            :before-read="beforeRead"
                            :after-read="fileUpload"
                            class="uploader"
                            v-model="zch"
                            :max-count="5"
                            :before-delete="deleteCl"
                    ></van-uploader>
                </div>-->
                <info-title title-content="身份证明材料" required-description="必填"/>
                <div v-for="(item, index) in sfzml"
                     :key="item.ryid + index">
                    <van-field class="fd-com-person-name van-field--column van-field--no-value"
                            disabled
                            :label="item.rymc"
                    ></van-field>
                     <van-uploader
                            :before-read="beforeRead"
                            :name="item.ryid"
                            :after-read="fileUpload"
                            class="uploader"
                            v-model="item.clList"
                            :max-count="5"
                            :before-delete="deleteCl"
                    ></van-uploader>
                    <!-- <UploadFile :ref="'sfzml'+index"
                                :is-b-q="true"
                                :id="bqid"
                                upload-url="ssbq/api/sccls/dbxx/fileupload"
                                del-url="ssbq/api/sccls/sccls/delsccl"
                                cllx="3"
                                :list="item.clList"
                                key-name="cSqclid"
                    ></UploadFile> -->
                </div>
                <info-title v-if="isShowDbxx" title-content="担保材料" required-description="必填"/>
                <div v-for="(item, index) in dbl"
                     :key="item.dbid + index">
                    <van-field class="van-field--column van-field--no-value"
                            disabled
                            :label="item.dblxmc"
                    ></van-field>
                    <div v-if="(item.dblxmc.indexOf('保险公司诉责险')>-1) && item.nSysbuy === 1">
                        <span style="color: #666;font-size: 14px;margin-left: 0.5rem;margin-right: 0.5rem"  @click="downloadFileBD(item.dbid)">电子保单.pdf</span>
                        <span style="color: #666;font-size: 14px;"  @click="downloadFileBH(item.dbid)">电子保函.pdf</span>
                    </div>
                         <van-uploader
                            :name="item.dbid"
                            :after-read="fileDblUpload"
                            class="uploader"
                            v-model="item.clList"
                            :max-count="uploadFileLength(item.nSysbuy)"
                            :before-delete="deleteCl"
                        ></van-uploader>
                    <!-- <UploadFile :ref="'dbl'+index"
                                :is-b-q="true"
                                :id="bqid"
                                upload-url="ssbq/api/sccls/dbxx/fileupload"
                                del-url="ssbq/api/sccls/sccls/delsccl"
                                cllx="4"
                                :list="item.clList"
                                key-name="cSqclid"></UploadFile> -->
                </div>
                <info-title title-content="证据材料" required-description="必填"/>
                <van-uploader
                        name="5"
                        :before-read="beforeRead"
                        :after-read="fileUpload"
                        class="uploader"
                        v-model="zjl"
                        :max-count="20"
                        :before-delete="deleteCl"
                ></van-uploader>
                <info-title title-content="其他材料"/>
                 <van-uploader
                        name="255"
                        :before-read="beforeRead"
                        :after-read="fileUpload"
                        class="uploader"
                        v-model="qt"
                        :max-count="20"
                        :before-delete="deleteCl"
                ></van-uploader>
            </van-cell-group>
        </div>
        <div class="fd-com-btn-container">
            <van-button
                    type="info"
                    round plain
                    :disabled="!saveBtnClickable"
                    @click="temporaryStorageBq"
            >
                暂存
            </van-button>
            <van-button
                    type="info"
                    round
                    :disabled="!saveBtnClickable || isSubmitting"
                    @click="submitPreservationInfo()"
            >
                提交
            </van-button>
        </div>
        <div class="uploading-wrap" v-show="isUpload">
            <div class="upload-text">
                <van-loading class="icon-upload"  type="spinner" />
                <span>上传中...</span>
            </div>
        </div>
        <div class="submitting-wrap" v-show="isSubmitting">
            <div class="submit-text">
                <van-loading class="icon-upload" type="spinner" />
                <span>提交中，请稍等（{{ submitCountdown }}s）</span>
            </div>
        </div>
    </div>
</template>

<script>
    import UploadFile from '../../components/common/uploadFile'
    import wx from 'weixin-js-sdk'
    import MyTitle from '../../components/common/myTitle';
    // 标题栏
    import acTitleBar from '@/components/app/title-bar/index.vue';
    import InfoTitle from '../../components/common/InfoTitle';
    import {columnsAjlx} from '../../utils/option';
    import {typeDbqk,typeXwbqsx,zjlxType,yjwjType} from "../../filters/index";
    import {
        typeBqlb,
        typeBqlx,
        typeFsccFsqj,
        typeDbzt,
        typeTjrlx,
        typeRylx,
        typeDlrlx,
        typeCclx,
        typeAjlx,
        typeDbfs,
        typeWxdb,
        typeSddy
    }
        from '../../filters/index';
    import validate from '@/utils/validator/validator';
    import {
        sqsclRule,
        sxflwsRule,
        qszclRule,
        SfzmlclRule,
        zjlclRule,
        sqrxxRule, // 申请人信息
        bsqrxxRule, // 被申请人信息

        ccckxxRule, // 财产查控信息
        lasltzsRule, // 立案受理通知书
        DblclRule, //担保类材料
        dbxxRule, // 担保信息
    } from '@/utils/validator/rules';
    import {Dialog, Toast,Notify} from 'vant'
    import {getToken} from "../../utils/auth";
    import {getXcxXwList, delXcxXw, getXcxZjList, delXcxZj} from '../../api/guarantee';

    export default {
        data() {
            return {
                // 对接在线服务网新增——是否显示诉讼案号下拉列表
                showAddPerson: false,
                // 对接在线服务网新增——人员下拉列表数据
                personList: [
                    // {
                    //     js: '原告',
                    //     name: '测试人员1'
                    // },
                    // {
                    //     js: '被告',
                    //     name: '测试人员2'
                    // },
                    // {
                    //     js: '第三人',
                    //     name: '测试人员3'
                    // }
                ],
                // 对接在线服务网新增——当前添加人员的类型
                currentType: '',
                // 对接在线服务网新增——当前选中的人员数据，用于回显到其它页面里
                addPersonInfo: {},
                bqid: '',
                bxgs: '',
                cAyzt:'',
                cAyxw:'',
                cXzaymc:'',
                cAhNf:'',
                formData: {
                    cBqah: '',
                    nAjlx: '',
                    cAy: ''
                },
                formData_1: {
                    cBqah: '',
                    nAjlx: '',
                    cAy: '',
                },
                bqJbxx: {
                    cSqdyfymc: '',
                    cBqzt:'',
                    cBqlx: '',
                    cBqlb: '',
                    cBqlbText: '',
                    cFsqj: '',
                    nSqbqje: '',
                    nSqbqdcsfy: '',
                    cDbzt: '',
                    cTjr: '',
                    dtTjsj: '', // 提交日期, 未返回值暂用创建申请日期
                    dtCreatetime: '', // 创建申请日期
                    cTjrlx: '',
                    cDbqk: '',
                    cDbqkText: '',
                    nWdbyy:'',//无担保原因
                    nWdbyyText:'',
                },
                bqSqrxxs: [],
                bqBsqrxxs: [],
                bqDlrxxs: [],
                bqCcxsxxs: [],
                // 证据信息
                bqZjxx: [],
                bqXwxx:[],
                bqCcckxxs: [],
                bqDbxxs: [],
                bqccxszjz: '',
                dbxxzjz: '',
                showAjlx: false,
                columnAjlx: columnsAjlx,
                sqs: [], // 申请书材料
                sxflws: [], //生效法律文书
                lasltzs: [], // 立案受理通知书材料
                qsz: [], // 起诉状材料,
                sfzml: [], // 身份证明类材料
                dbl: [], // 担保类
                zjl: [], // 证据类材料
                qt: [], // 其他
                cczjz: 0, // 财产总价值,
                isXsShow: 1,// 用于财产线索显示 1显示2不显示
                isCkShow: 2,// 用于财产查控显示 1显示2不显示
                isXwShow: 0,// 用于行为信息显示 0不显示1显示
                isZjShow: 0,// 用于证据信息显示 0不显示1显示
                isDownload: 2, // 添加的担保为诉责险时显示下载保单保函
                saveBtnClickable: true, // 保存按钮是否可以点击,
                isShowDbxx: null,//是否展示担保信息
                scroll:0,//保留上次离开的高度
                isFirst:null,
                isActived:null,
                isUpload:null,
                bqlx:'',
                isSubmitting: false, // 提交中遮罩
                submitCountdown: 30, // 提交倒计时（秒）
                submitTimer: null, // 提交倒计时定时器
                submitRequestId: 0, // 提交请求标识，避免超时后重复处理

                ayLabel_1:'',
                ayLabel_2:''
            }
        },
        name: "createPreservationBasic",
        components: {
            MyTitle,
            InfoTitle,
            UploadFile,
            acTitleBar
        },
        computed: {
            //担保物名称
            cDbwmc() {
                return item => {
                    if (item.cDbfs == 5) {
                        return `${typeDbfs(item.cDbfs)}-${item.cBxgsmc}`
                    } else if (item.cDbfs == 1) {
                        return `${typeDbfs(item.cDbfs)}-保证金`
                    } else if ( item.cDbfs == 2) {
                        return `${typeDbfs(item.cDbfs)}-${item.cDbwmc}`
                    } else {
                        return `${typeDbfs(item.cDbfs)}-${item.dBwmc}`
                    }
                }
            }
        },
        methods: {

            /**
             * @function
             * @description 对接在线服务网新增——打开添加人员信息弹层
             * @param {String} type 类型（sqr：申请人；bsqr：被申请人；dlr：代理人）
             * @return {undefined} 无返回值
             */
            openAddPerson(type) {
                const params = {
                    bqid: this.bqid,
                    type: this.currentType,
                    zxfwToken: localStorage.getItem('zxfwtoken')
                };
                this.$axios.post('ssbq/api/bqyzw/bqsq/ajdsrs', params).then((res) => {
                    if (res.code === 200) {
                        this.personList = res.data;
                        // 新增name字段，不然下拉无法正常展示
                        for (let index = 0; index < this.personList.length; index++) {
                            if (type === 'sqr') {
                                // 申请人
                                this.personList[index].name = this.personList[index].cSqrxm || this.personList[index].cQymc;
                            } else if (type === 'bsqr') {
                                // 被申请人
                                this.personList[index].name = this.personList[index].cDsrxm || this.personList[index].cQymc;
                            } else if (type === 'dlr') {
                                // 代理人
                                this.personList[index].name = this.personList[index].cDlrxm;
                            }
                        }
                        // 显示下拉弹层
                        this.showAddPerson = true;
                    } else {
                        console.log('诉讼人员列表获取失败');
                        Notify('诉讼人员列表获取失败');
                    }
                });
            },

            /**
             * @function
             * @description 对接在线服务网新增——添加人员信息弹层
             * @return {undefined} 无返回值
             */
            confirmAddPerson(item) {
                // 关闭弹层
                this.showAddPerson = false;
                // 把当前点击添加的人员数据存入缓存中，回显到原来的添加页面里
                this.addPersonInfo = item;
                sessionStorage.setItem("addPersonInfo", JSON.stringify(this.addPersonInfo));
                if (this.currentType === 'sqr') {
                    // 申请人
                    this.addBqSQR();
                } else if (this.currentType === 'bsqr') {
                    // 被申请人
                    this.addBqBSQR();
                } else if (this.currentType === 'dlr') {
                    // 代理人
                    this.addBqYgdlr();
                }
            },

            /**
             * @function
             * @description 对接在线服务网新增——点击添加申请人按钮
             * @return {undefined} 无返回值
             */
            clickAddSqr() {
                // 诉讼保全时，打开添加人员信息弹层
                if (this.bqJbxx.cBqlb === '2') {
                    this.currentType = 'sqr';
                    this.openAddPerson(this.currentType);
                } else {
                    // 诉前保全等，走原来的添加逻辑
                    this.addBqSQR();
                }
            },

            /**
             * @function
             * @description 对接在线服务网新增——点击添加被申请人按钮
             * @return {undefined} 无返回值
             */
            clickAddBsqr() {
                // 诉讼保全时，打开添加人员信息弹层
                if (this.bqJbxx.cBqlb === '2') {
                    this.currentType = 'bsqr';
                    this.openAddPerson(this.currentType);
                } else {
                    // 诉前保全等，走原来的添加逻辑
                    this.addBqBSQR();
                }
            },

            /**
             * @function
             * @description 对接在线服务网新增——点击添加原告代理人按钮
             * @return {undefined} 无返回值
             */
            clickAddYgdlr() {
                // 诉讼保全时，打开添加人员信息弹层
                if (this.bqJbxx.cBqlb === '2') {
                    this.currentType = 'dlr';
                    this.openAddPerson(this.currentType);
                } else {
                    // 诉前保全等，走原来的添加逻辑
                    this.addBqYgdlr();
                }
            },

            /**
             * 返回
             * */
            back() {
                this.$router.push('/home/myPreservation');
            },
            uploadFileLength(nSysbuy) {
                return nSysbuy === 1 ? 3 : 5
            },
            toastWxdb(value){
                Toast(value);
            },
            //编辑基本信息
            editBasic(){
                this.$router.push({
                    path: '/editBasic',
                })
            },
            //案号案由提示
            toast(value) {
                Toast(value);
            },
            getBqJbxx() {
                return new Promise((resolve) => {
                    let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                    this.bqid = bqid
                    this.$axios.get('ssbq/api/bqsqinfo?bqid=' + bqid).then(res => {
                        // 获取案号案由案件类型, 提交时需要一并提交
                        let {cAhNf, nAjlx} = res.data;
                        var key = (Number(cAhNf) >= 2021) ? 2021 : 2020;
                        if (key === 2020) {
                            this.ayLabel_1 = Number(nAjlx) === 6 ? '案由(主体类型)' : '案由';
                            this.ayLabel_2 = '案由(行为种类)';
                        } else {
                            this.ayLabel_1 = Number(nAjlx) === 6 ? '行政主体类型' : '案由';
                            this.ayLabel_2 = '行政案由';
                        }

                        this.formData.cAy = res.data.cAy;
                        if(nAjlx == 6){
                            let ay = res.data.cAy.split(";");
                            this.cAyzt = ay[0];
                            let cAyzlarr = [];
                            ay.map((item, index) => {
                                if(index != 0){
                                    cAyzlarr.push(item)
                                }
                            })
                            if(key===2021){
                                this.cAyxw = res.data.cAyxzxwName;
                            }else{
                                this.cAyxw = cAyzlarr.join(";")
                            }

                            this.cXzaymc = res.data.cXzaymc;
                        }
                        this.formData.cBqah = res.data.cBqah;
                        //this.formData_1.nAjlx = res.data.nAjlx;
                        this.cAhNf=cAhNf;
                        // this.formData.cBqah = `（${res.data.cAhNf}）${res.data.cAhFydz}${res.data.cAhAjlxdz}${res.data.cAhAjxh}`;
                        this.formData_1.nAjlx = nAjlx;

                        this.bqJbxx.cSqdyfymc = res.data.cSqdyfymc
                        this.bqJbxx.cBqlx = typeBqlx(res.data.cBqlx)
                        this.bqJbxx.cBqlb = res.data.cBqlb;
                        this.bqJbxx.cBqzt= res.data.cBqzt;
                        this.bqJbxx.cBqlbText = typeBqlb(res.data.cBqlb)
                        this.bqJbxx.cFsqj = typeFsccFsqj(res.data.cFsqj)
                        this.bqJbxx.nSqbqje = res.data.nSqbqje
                        this.bqJbxx.nSqbqdcsfy = res.data.nSqbqdcsfy
                        this.bqJbxx.cDbzt = typeDbzt(res.data.cDbzt)
                        this.bqJbxx.cTjr = res.data.cTjr
                        this.bqJbxx.dtTjsj = res.data.dtTjsj||'--'
                        this.bqJbxx.cTjrlx = typeTjrlx(res.data.cTjrlx)
                        let data = res.data;
                        this.bqJbxx.dtCreatetime = data.dtCreatetime;
                        this.bqJbxx.cDbqk = data.cDbqk;
                        // this.isShowDbxx = data.cDbqk;
                        if(res.data.cBqlb!=='4'){
                            this.isShowDbxx=(data.cDbqk!=='3');
                        }else{
                            this.isShowDbxx=(data.cDbqk!=='2');
                        }

                        this.bqJbxx.cDbqkText = typeDbqk(data.cDbqk);
                        // this.formData.cBqah = data.cBqah;
                        // this.formData.cAy = data.cAy;
                        this.formData_1.nAjlx = data.nAjlx;
                        this.formData.nAjlx = typeAjlx(data.nAjlx);
                        this.bqJbxx.nWdbyy = res.data.nWdbyy;
                        this.bqJbxx.nWdbyyText = typeWxdb(res.data.nWdbyy)
                        resolve(res.data)
                    })
                })
            },
            getBqSqrxx() {
                this.bqSqrxxs = [];
                return new Promise((resolve) => {
                    let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                    this.$axios.get('ssbq/api/sqrs?bqid=' + bqid).then(res => {
                        res.data.forEach((item) => {
                            let sqr = {}
                            sqr.sqrlx = typeRylx(item.cSqrlx)
                            sqr.sqrid = item.cId
                            if (item.cSqrlx == "1") {
                                sqr.sqrmc = item.cSqrxm.length > 15 ? item.cSqrxm.substring(0, 15) + "..." : item.cSqrxm;
                            } else {
                                sqr.sqrmc = item.cQymc.length > 15 ? item.cQymc.substring(0, 15) + "..." : item.cQymc;
                            }
                            this.bqSqrxxs.push(sqr)
                        })
                        //申请人去重
                        let obj = {};
                            this.bqSqrxxs = this.bqSqrxxs.reduce(function (item, next) {
                                obj[next.sqrid] ? '' : obj[next.sqrid] = true && item.push(next);
                                    return item;
                                }, []);
                        resolve()
                    })
                })
            },
            getBqBsqrxx() {
                this.bqBsqrxxs = [];
                return new Promise((resolve) => {
                    let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                    this.$axios.get('ssbq/api/bsqrs?bqid=' + bqid).then(res => {
                        window.sessionStorage.setItem("bsqrList",JSON.stringify(res.data))
                        res.data.forEach((item) => {
                            let bsqr = {}
                            bsqr.bsqrid = item.cBqDsrid
                            bsqr.bsqrlx = typeRylx(item.cDsrlx)
                            if (item.cDsrlx == "1") {
                                bsqr.bsqrmc = item.cDsrxm.length > 15 ? item.cDsrxm.substring(0, 15) + "..." : item.cDsrxm;
                            } else {
                                bsqr.bsqrmc = item.cQymc.length > 15 ? item.cQymc.substring(0, 15) + "..." : item.cQymc;
                            }
                            this.bqBsqrxxs.push(bsqr)
                        })
                        //被申请人去重
                        let obj = {};
                        this.bqBsqrxxs = this.bqBsqrxxs.reduce(function (item, next) {
                            obj[next.bsqrid] ? '' : obj[next.bsqrid] = true && item.push(next);
                                return item;
                        }, []);
                        resolve()
                    })
                })
            },
            getBqDlrxx() {
                this.bqDlrxxs = [];
                return new Promise((resolve) => {
                    let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                    this.$axios.get('ssbq/api/ygdlrs?bqid=' + bqid).then(res => {
                        res.data.forEach((item) => {
                            let dlr = {};
                            dlr.dlrid = item.cBqDlrid;
                            dlr.dlrmc = item.cDlrxm.length > 20 ? item.cDlrxm.substring(0, 20) + "..." : item.cDlrxm;
                            dlr.dlrlx = typeDlrlx(item.cDlrlx);
                            this.bqDlrxxs.push(dlr);
                        })
                        //原告代理人去重
                        let obj = {};
                        this.bqDlrxxs = this.bqDlrxxs.reduce(function (item, next) {
                            obj[next.dlrid] ? '' : obj[next.dlrid] = true && item.push(next);
                                return item;
                        }, []);
                        resolve()
                    })
                })
            },
            // 上传验证
            beforeRead(file) {
                if (file.size == 0) {
                    Notify('上传文件必须大于0kb!')
                }
                let fileType = "image/jpeg||image/jpg||image/bmp||image/gif||image/png"
                let imgFormat = "jpg、png、jpeg、bmp、gif"
                if (fileType.indexOf(file.type) === -1) {
                    Notify({
                        message: `仅支持格式为${imgFormat}的图片!`,
                        type: 'danger',
                        duration: 5 * 1000
                    })
                    return false;
                } else if (file.size > (20 * 1024 * 1024)) {
                    Notify('上传文件大小不能超过20MB!')
                    return false;
                }
                return true;
            },
            async fileUpload(file, name) {
                this.isUpload = true;
                this.saveBtnClickable = false;
                // cllx 1申请书, 6立案受理通知书, 2起诉状, 3身份证明类, 5证据类, 255其他
                let currentBqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                let i = 0;
                let clid = await this.myId(i);
                const fd = new FormData();
                // name.name不为1, 2, 5, 6, 255时,name.name代表所属申请人id,cllx为3身份证明类
                let cllx = name.name;
                if (cllx != "1" && cllx != "2" && cllx != "5" && cllx != "6"&& cllx != "10" && cllx != "255") {
                    fd.append("id", cllx);
                    cllx = 3;
                }
                let f = file.file;
                fd.append("files", f);
                fd.append("bqid", currentBqid);
                fd.append("cllx", cllx);
                fd.append("clid", clid);
                // let xhr = new XMLHttpRequest();
                // xhr.open("post", "http://36.110.41.67:8536/wsbq/ssbq/api/sccls/dbxx/fileupload", true);
                // xhr.send(fd);
                // xhr.onreadystatechange = (res)=>{
                // //当readyState变化时执行 （作为上传结果不可靠）
                //     if(xhr.readyState==4){
                //         this.isUpload = false;
                //         if(xhr.status==200){
                //              this.$notify({'type': 'success', 'message': '材料上传成功'});
                //         }else{
                //             this.$notify(xhr.statusText);
                //         }
                //         this.initClxxData();
                //         this.saveBtnClickable = true;
                //     }else{
                //          this.saveBtnClickable = true;
                //     }
                // };
                this.$axios.post('ssbq/api/sccls/dbxx/fileupload', fd)
                        .then((res) => {
                            this.isUpload = false;
                            if(res.code == 200){
                                this.$notify({'type': 'success', 'message': '材料上传成功'});
                            }else{
                                this.$notify(res.message);
                            }
                            this.initClxxData();
                            this.saveBtnClickable = true;
                        }).catch(() => {
                        this.saveBtnClickable = true;
                });
            },
            async fileDblUpload(file, name) {
                this.isUpload = true;
                this.saveBtnClickable = false;
                let currentBqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                let i = 0;
                let clid = await this.myId(i);
                const fd = new FormData();
                let id = name.name;
                let f = file.file;
                fd.append("files", f);
                fd.append("bqid", currentBqid);
                fd.append("cllx", "4");
                fd.append("id", id);
                fd.append("clid", clid);
                this.$axios.post('ssbq/api/sccls/dbxx/fileupload', fd)
                        .then(res => {
                            this.isUpload = false;
                            if(res.code == 200){
                                this.$notify({'type': 'success', 'message': '材料上传成功'});
                            }else{
                                this.$notify(res.message);
                            }
                            this.initClxxData();
                            this.saveBtnClickable = true;
                        }).catch(function (error) {
                        console.log(error)
                        this.saveBtnClickable = true;
                });
            },
             deleteCl: function (name) {
                if(this.isUpload != true){
                    this.$axios.delete('ssbq/api/sccls/sccls/delsccl?id=' + name.cSqclid +"&bqid=" + this.bqid)
                        .then(() => {
                            this.initClxxData();
                            this.$notify({'type': 'success', 'message': '材料删除成功'});
                        }).catch(() => {
                    });
                }else{
                    this.$notify("上传过程中不能删除！");
                }
            },
            getBqCcxsxx() {
                this.bqCcxsxxs = [];
                return new Promise((resolve) => {
                    let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                    // this.getBqBsqrxx().then(()=>{
                        this.$axios.get('ssbq/api/sqbq/ccxss?bqid=' + bqid).then(res => {

                            let ccjz = 0;
                            res.data.forEach((item) => {
                                let ccxs = {};
                                let syrid = item.cSqbqccyyz;
                                let dsrs = this.bqBsqrxxs;
                                let syrmc = '';
                                for (let i = 0; i < dsrs.length; i++) {
                                    if (syrid == dsrs[i].bsqrid) {
                                        syrmc = dsrs[i].bsqrmc;
                                        break;
                                    }
                                }
                            ccxs.ccxsmc = typeCclx(item.cCclx)+ ":  " + (syrmc.length > 15 ? syrmc.substring(0, 15) + "..." : syrmc) ;
                            ccxs.ccxsjz = item.cSqbqccje + "元";
                            ccxs.ccxsid = item.cBqppid;
                            ccxs.cSqbqccje = item.cSqbqccje;
                            this.bqCcxsxxs.push(ccxs);
                            //财产线索去重
                            let obj = {};
                            this.bqCcxsxxs = this.bqCcxsxxs.reduce(function (item, next) {
                                obj[next.ccxsid] ? '' : obj[next.ccxsid] = true && item.push(next);

                                    return item;
                                }, []);
                                ccjz += (Number(item.cSqbqccje) * 100)
                            })
                        this.cczjz = (ccjz / 100).toFixed(2);
                        this.bqccxszjz = "财产总价值：" + this.cczjz + "元";
                        resolve();


                        })
                    // })
                })
            },
            getBqZjxx(){
                this.bqZjxx=[];
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                getXcxZjList({bqid}).then(res=>{
                    if(res.code===200&&res.data.length>0){
                        res.data.map(item=>{
                            this.bqZjxx.push({
                                cId:item.cId,
                                // 证据类型
                                nZjlx: zjlxType(item.nZjlx),
                                // 证据名称
                                cZjmc: item.cZjmc,
                                // 原件原物
                                nYjwj: yjwjType(item.nYjwj),
                                // 证据来源
                                cZjly: item.cZjly,
                                // 证据说明
                                cZjsm: item.cZjsm,
                            });
                        });
                    }
                });
            },
            getBqXwxx(){
                this.bqXwxx=[];
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                getXcxXwList({bqid}).then(res=>{
                    if(res.code===200&&res.data.length>0){
                        res.data.map(item=>{
                            this.bqXwxx.push({
                                cId:item.cId,
                                nXwbqsx:typeXwbqsx(item.nXwbqsx),
                                cSxsm:item.cSxsm
                            });
                        });
                    }
                });
            },
            getBqCcckxx() {
                this.bqCcckxxs = [];
                return new Promise((resolve) => {
                    let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                    this.$axios.get("ssbq/api/sccls/sccl/cllx?bqid=" + bqid + "&cllx=" + 7)
                        .then(res => {
                            if (res.code == 200) {
                                if (res.data.length > 0) {
                                    this.bqCcckxxs = res.data;
                                }
                            } else {
                                this.$notify(res.message);
                            }
                        }).catch(() => {
                    });
                    resolve()
                })
            },
            onConfirmAjlx(item) {
                this.formData.nAjlx = item.text;
                this.formData_1.nAjlx = item.keyId;
                this.showAjlx = false
            },
            addBqSQR() {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                sessionStorage.setItem("sqrId", JSON.stringify(""));
                this.$router.push({
                    path: '/addBqSQR',
                })
            },
            addBqBSQR() {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                sessionStorage.setItem("bsqrId", JSON.stringify(""));
                this.$router.push({
                    path: '/addBqBSQR',
                })
            },
            addBqYgdlr() {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                sessionStorage.setItem("ygdlrId", JSON.stringify(""));
                this.$router.push({
                    path: '/addBqYgdlr',
                })
            },
            // 财产线索
            addBqCcxs() {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                sessionStorage.setItem("bqCcxsId", "");
                this.$router.push({
                    path: '/addBqCcxs',
                })
            },
            // 证据信息
            addBqZjxx() {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                sessionStorage.setItem("bqZjxxId", "");
                this.$router.push({
                    path: '/addBqZjxx',
                })
            },
            // 行为信息
            addBqXwxx() {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                sessionStorage.setItem("bqXwxxId", "");
                this.$router.push({
                    path: '/addBqXwxx',
                })
            },
            addBqCcck() {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                this.$router.push({
                    path: '/addBqCcck',
                })
            },
            editSQR(item) {
                // 对接在线服务新增——移除回显选择添加的诉讼案件相关人员信息
                sessionStorage.removeItem('addPersonInfo');
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                sessionStorage.setItem("sqrId", JSON.stringify(item.sqrid));
                this.$router.push({
                    path: '/addBqSQR',
                })
            },
            editBqBsqr(item) {
                // 对接在线服务新增——移除回显选择添加的诉讼案件相关人员信息
                sessionStorage.removeItem('addPersonInfo');
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                sessionStorage.setItem("bsqrId", JSON.stringify(item.bsqrid));
                this.$router.push({
                    path: '/addBqBSQR',
                })
            },
            editBqYgdlr(item) {
                // 对接在线服务新增——移除回显选择添加的诉讼案件相关人员信息
                sessionStorage.removeItem('addPersonInfo');
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                sessionStorage.removeItem("bqSqrInfo");
                // window.sessionStorage.removeItem('Dlrlx')
                sessionStorage.setItem("ygdlrId", JSON.stringify(item.dlrid));
                sessionStorage.setItem("ygdlrIds",JSON.stringify(item.dlrid))
                this.$router.push({
                    path: '/addBqYgdlr',
                })
            },
            goToAddBqCCXS: function (ccxsId) {
                sessionStorage.setItem("bqCcxsId", ccxsId);
                this.$router.push({
                    path: "/addBqCCXS"
                });
            },
            // 证据信息
            goToAddBqZjxx: function (zjxxid) {
                sessionStorage.setItem("bqZjxxId", zjxxid);
                this.$router.push({
                    path: "/addBqZjxx"
                });
            },
            goToAddBqXwxx: function (xwxxid) {
                sessionStorage.setItem("bqXwxxId", xwxxid);
                this.$router.push({
                    path: "/addBqXwxx"
                });
            },
            addBqDbxx: function () {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("bxgs",JSON.stringify(this.bxgs))
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                sessionStorage.setItem("cDbxxId", JSON.stringify(""));
                this.$router.push({
                    path: "/addBqDbxx"
                });
            },
            initClxxData: function () {
                this.sqs = []
                this.sxflws = []
                this.lasltzs = []
                this.qsz = []
                this.sfzml = []
                this.zjl = []
                this.dbl = []
                this.qt = []
                let currentBqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                this.$axios.get('ssbq/api/sccls/sccls?bqid=' + currentBqid)
                    .then(res => {
                        let data = res.data;
                        this.sqs = data.sqs; // 申请书材料
                        this.sxflws = data.sxflws; //生效法律文书
                        this.qsz = data.qsz; // 起诉状材料,
                        this.sfzml = data.sfzml; // 身份证明类材料
                        // 当前后台返回人员名称格式为 姓名-类型
                        // 当前要展示格式为 类型-姓名 需要通过 - 分割返回字段值, 调换展示顺序和处理过长的姓名
                       /* this.sfzml.forEach(ele => {
                            let rymcAndType = ele.rymc;
                            if (rymcAndType) {
                                let arr = rymcAndType.split('-');
                                let name = arr[0];
                                let type = arr[1];
                                name = name.length > 15 ? name.substr(0, 15) + '...' : name;
                                ele.rymc = type + '-' + name;
                            }
                        });*/
                        this.dbl = data.dbl; // 担保类
                        this.zjl = data.zjl; // 证据类材料
                        this.lasltzs = data.lasltzs; // 立案受理通知书材料
                        this.qt = data.qt; // 其他
                    }).catch(() => {
                });
            },
            async validateFormData () {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                let cks  = await this.$axios.get("ssbq/api/sccls/sccl/cllx?bqid=" + bqid + "&cllx=" + 7)
                cks = cks.data
                let descriptor = {
                    bqSqrxxs: sqrxxRule,
                    bqBsqrxxs: bsqrxxRule,
                };

                if (this.isShowDbxx) {
                    descriptor.bqDbxxs = dbxxRule;
                }
                let data = Object.assign({}, this.formData);
                data.bqSqrxxs = this.bqSqrxxs;
                data.bqBsqrxxs = this.bqBsqrxxs;
                data.bqDlrxxs = this.bqDlrxxs;
                if (this.isXsShow===1 && !cks.length && !this.bqCcxsxxs.length) {
                    if(!this.bqCcxsxxs.length){
                        data.bqCcxsxxs = this.bqCcxsxxs;
                        descriptor.bqCcxsxxs = ccckxxRule;
                    }else{
                        data.bqCcckxxs = cks;
                    }
                    descriptor.bqCcckxxs = ccckxxRule;
                }
                if (this.isShowDbxx) {
                    data.bqDbxxs = this.bqDbxxs;
                }
                let validated = validate(descriptor, data);
                return validated;
            },
            validateClxx: function () {
                let descriptor = {
                    sqs: sqsclRule, // 申请书材料 必填
                    //qsz: qszclRule, // 起诉状材料 必填
                    // sfzml: new SfzmlclRule(true), // 身份证明类材料 必填,分别校验每个申请人
                    // zjl: zjlclRule // 证据类材料 必填
                };
                if (this.bqJbxx.cBqlb == 4){
                    descriptor.sxflws = sxflwsRule;
                }
                descriptor.sfzml=new SfzmlclRule(true);// 身份证明类材料 必填,分别校验每个申请人

                if (this.bqJbxx.cBqlb == 2 && this.bqJbxx.cBqlb != 4){
                    descriptor.qsz = qszclRule;
                }
                if (this.bqJbxx.cBqlb == 2 && this.bqJbxx.cBqlb != 4) {
                    // 诉讼保全时 立案受理通知书 必填
                    descriptor.lasltzs = lasltzsRule;
                }
                let dbls = [];
                this.dbl.some((item) => {
                    dbls.push(item);
                    if(item.nSysbuy == 1){
                        return;
                        //  descriptor.dbl=new DblclRule(false);//担保类材料诉责险 非必填
                    }else{
                         descriptor.dbl=new DblclRule(true);//担保类材料 必填
                    }
                })
                this.dbl.some((item, i) => {
                    if (item.dblxmc == "诉讼保全责任保险") {
                        this.dbl.splice(i, 1);
                    }
                });
                this.dbl = dbls;

                descriptor.zjl=zjlclRule // 证据类材料 必填

                var dataList={
                    sqs: this.sqs, // 申请书材料 必填
                    qsz: this.qsz, // 起诉状材料 必填
                    // zcsltzs:this.zcsltzs,//仲裁受理通知书
                    // zch:this.zch,
                    sfzml: this.sfzml, // 身份证明类材料 必填,分别校验每个申请人
                    zjl: this.zjl, // 证据类材料 必填
                    dbl: this.dbl, // 担保类
                    lasltzs: this.lasltzs, // 立案受理通知书
                };

                const validated = validate(descriptor, {
                    sqs: this.sqs, // 申请书材料 必填
                    sxflws:this.sxflws,//生效法律文书 必填
                    qsz: this.qsz, // 起诉状材料 必填
                    sfzml: this.sfzml, // 身份证明类材料 必填,分别校验每个申请人
                    zjl: this.zjl, // 证据类材料 必填
                    dbl: this.dbl, // 担保类
                    lasltzs: this.lasltzs // 立案受理通知书
                });
                return validated;
            },
            clearSubmitTimer: function () {
                if (this.submitTimer) {
                    clearInterval(this.submitTimer);
                    this.submitTimer = null;
                }
            },
            startSubmitCountdown: function () {
                this.clearSubmitTimer();
                this.isSubmitting = true;
                this.submitCountdown = 30;
                this.saveBtnClickable = false;
                this.submitTimer = setInterval(() => {
                    if (this.submitCountdown <= 1) {
                        // 超过30s未返回结果，允许重新提交
                        this.clearSubmitTimer();
                        this.isSubmitting = false;
                        this.submitCountdown = 30;
                        this.saveBtnClickable = true;
                        return;
                    }
                    this.submitCountdown -= 1;
                }, 1000);
            },
            finishSubmitRequest: function (requestId) {
                // 仅处理当前有效提交；超时后若用户已重新提交则忽略旧请求
                if (requestId !== this.submitRequestId) {
                    return false;
                }
                this.clearSubmitTimer();
                this.isSubmitting = false;
                this.submitCountdown = 30;
                this.saveBtnClickable = true;
                return true;
            },
            submitPreservationInfo: function () {
                if (this.isSubmitting || !this.saveBtnClickable) {
                    return;
                }
                // 校验表单信息是否完整
                const validated = this.validateFormData();
                validated.then(() => {
                    // 校验上传材料信息是否完整
                    const validateClxx = this.validateClxx();
                    validateClxx.then(() => {
                        // 表单校验通过, 调用接口保存担保详情信息
                        this.formData_1.cBqah = this.formData.cBqah;
                        this.formData_1.cAy = this.formData.cAy;
                        // 此处提交的案件信息是创建页面上传到服务器的
                        let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                        const requestId = ++this.submitRequestId;
                        this.startSubmitCountdown();
                        this.$axios.post("ssbq/api/xcx/xcxbqjbxx?bqid=" + bqid, this.formData_1)
                            .then((res) => {
                                if (!this.finishSubmitRequest(requestId)) {
                                    return;
                                }
                                window.sessionStorage.setItem("submitAfter", this.$router.name);
                                if (res.code == 200 || res.code == 204) {
                                    this.$notify({'type': 'success', 'message': '提交保全成功'});
                                    this.$router.push("/home/myPreservation");
                                } else if (res.code == 500) {
                                    this.$notify({
                                        'type': 'danger',
                                        'message': res.message || '提交失败'
                                    });
                                } else if (res.message) {
                                    this.$notify({
                                        'type': 'danger',
                                        'message': res.message
                                    });
                                }
                            })
                            .catch(() => {
                                // 错误提示由 axios 拦截器统一处理，此处仅复位提交状态
                                this.finishSubmitRequest(requestId);
                            });
                    });
                });
            },
            deleteBqSQR: function (id, index) {
                Dialog.confirm({
                    title: '提示',
                    message: '删除申请人后，对应的原告代理人或身份证明材料可能会一并删除，确认删除吗？',
                    confirmButtonColor: '#ffffff',
                    cancelButtonColor: '#ffffff'
                }).then(() => {
                    this.$axios.delete('ssbq/api/bqsqs/sqr?id=' + id +"&bqid=" + this.bqid)
                        .then(() => {
                            this.$notify({'type': 'success', 'message': '删除成功'});
                            this.getBqSqrxx();
                            this.getBqDlrxx();
                            this.initClxxData();
                        }).catch((error) => {
                        console.log(error)
                    });
                }).catch(() => {

                });
                return;
            },
            deleteBqBSQR: function (id, index) {
                Dialog.confirm({
                    title: '提示',
                    message: '删除被申请人后，对应的财产线索会一并删除，确认删除吗？',
                    confirmButtonColor: '#ffffff',
                    cancelButtonColor: '#ffffff'
                }).then(() => {
                    this.$axios.delete('ssbq/api/bqsqs/bsqr?id=' + id +"&bqid=" + this.bqid)
                        .then(() => {
                            this.$notify({'type': 'success', 'message': '删除成功'});
                            this.getBqBsqrxx();
                            this.getBqCcxsxx().then(() => {
                                this.getBqCcckxx().then(() => {
                                    this.isCkOrXsShow();
                                });
                            });
                            this.bqBsqrxxs.splice(index, 1);
                        }).catch(() => {
                    });
                }).catch(() => {

                });
                return;
            },
            deleteBqYGDLR: function (id, index) {
                 Dialog.confirm({
                    title: '提示',
                    message: '删除原告代理人后，对应的原告代理人身份证明材料会一并删除，确认删除吗？',
                    confirmButtonColor: '#ffffff',
                    cancelButtonColor: '#ffffff'
                }).then(() => {
                    this.$axios.delete('ssbq/api/bqsqs/ygdlr?id=' + id +"&bqid=" + this.bqid)
                        .then(() => {
                            this.$notify({'type': 'success', 'message': '删除成功'});
                            this.getBqDlrxx();
                            this.initClxxData();
                        }).catch(() => {

                    });
                }).catch(() => {

                });
                return;
            },
            deleteBqCCXS: function (id, index) {
                this.cczjz = 0;
                this.bqCcxsxxs.forEach(temp => {
                    this.cczjz += (temp.cSqbqccje * 100);
                });
                this.bqccxszjz = "总价值：" + (this.cczjz / 100).toFixed(2) + "元";
                this.$axios.delete('ssbq/api/bqsqs/ccxs?id=' + id +"&bqid=" + this.bqid)
                    .then(() => {
                        this.$notify({'type': 'success', 'message': '删除成功'});
                        this.getBqCcxsxx().then(() => {
                            this.getBqCcckxx().then(() => {
                                this.isCkOrXsShow();
                            });
                        });
                        this.bqCcxsxxs.splice(index, 1);
                    }).catch(() => {

                });
            },
            // 删除证据信息
            deleteBqZjxx:function(id,index){
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                delXcxZj({bqid,id}).then(res=>{
                    if(res.code===200){
                        this.$notify({'type': 'success', 'message': '删除成功'});
                        this.bqZjxx.splice(index, 1);
                    }
                }).catch((error) => {console.log(error)});
            },
            deleteBqXwxx:function(id,index){
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                delXcxXw({bqid,id}).then(res=>{
                   if(res.code===200){
                       this.$notify({'type': 'success', 'message': '删除成功'});
                       this.bqXwxx.splice(index, 1);
                   }
                }).catch((error) => {console.log(error)});
            },
            isCkOrXsShow() {
                let xs = this.bqCcxsxxs;
                let ck = this.bqCcckxxs;
                let lb = this.bqJbxx.cBqlb;
                if (lb == "1") {
                    this.isCkShow = 2;
                } else {
                    if (xs.length <= 0 && ck <= 0) {
                        this.isCkShow = 1;
                        this.isXsShow = 1;
                    } else if (xs.length > 0) {
                        this.isCkShow = 2;
                        this.isXsShow = 1;
                    } else {
                        this.isCkShow = 1;
                        this.isXsShow = 2;
                    }
                }
            },
            temporaryStorageBq() {
                if( this.bqJbxx.cBqzt == "1" || this.bqJbxx.cBqzt == "3"){
                   this.$notify({'type': 'success', 'message': '暂存成功'});
                }else{
                    this.$notify('此保全已经提交过了，无需再次暂存');
                }
                this.saveBtnClickable = true;
            },
            getBqDbxx() {
                this.bqDbxxs = [];
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                this.$axios.get('ssbq/api/dbxxs?bqid=' + bqid)
                    .then(res => {
                        if (res.code == 200) {
                            let zjz = 0;
                            res.data.forEach((item) => {
                                zjz += Number(item.nDbjz * 100);
                                item.nDbjz = item.nDbjz + "元";
                                item.dBwmc = typeSddy(item.dBwmc);
                            })
                            this.bqDbxxs = res.data;
                            this.dbxxzjz = "担保总价值：" + (zjz / 100).toFixed(2) + "元"
                            sessionStorage.setItem('bqDbxxs', JSON.stringify(this.bqDbxxs))
                        } else {
                            this.$notify(res.message);
                        }
                    }).catch(() => {
                });
            },
            deleteBqDbxx(id, index) {
                 Dialog.confirm({
                    title: '提示',
                    message: '删除担保信息后，对应的担保材料会一并删除，确认删除吗？',
                    confirmButtonColor: '#ffffff',
                    cancelButtonColor: '#ffffff'
                }).then(() => {
                    let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                    this.$axios.delete('ssbq/api/xcx/xcxdbxx/' + '/' + bqid + '/' + id)
                        .then(() => {
                            // this.bqDlrxxs.splice(index, 1);
                            this.$notify({'type': 'success', 'message': '删除成功'});
                            this.getBqDbxx();
                            this.initClxxData();
                        }).catch(() => {

                    });
                }).catch(() => {

                });
                return;

            },
            goToEditBqDbxx(id) {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                sessionStorage.setItem("currentBqid", JSON.stringify(bqid));
                sessionStorage.setItem("cDbxxId", JSON.stringify(id));
                this.$router.push({
                    path: "/addBqDbxx"
                });
            },
            myId(i) {
                return new Promise((resolve) => {
                    i++
                    if (i > 3) {
                        this.$notify("系统异常");
                    } else {
                        this.getId().then((res) => {
                            resolve(res.data);
                        }).catch(() => {
                            this.myId(i)
                        })
                    }
                })
            },
            getId() {
                return new Promise((resolve) => {
                    this.$axios.get("ssbq/api/id")
                        .then(res => {
                            if (res.code == 200) {
                                resolve(res);
                            } else {
                                this.$notify(res.message);
                            }
                        }).catch(() => {
                        this.$notify("系统异常");
                    });
                });
            },
            // 下载保单
            downloadFileBD(dbid) {
                wx.miniProgram.navigateTo({
                    url: '/pages/download/download?id='+dbid+'&token='+getToken()
                })
            },
            // 下载保函
            downloadFileBH(dbid) {
                wx.miniProgram.navigateTo({
                    url: '/pages/downloadBh/downloadBh?id='+dbid+'&token='+getToken()
                })
            },
            initBXGS() {
                let bqid = JSON.parse(sessionStorage.getItem("currentBqid"));
                this.$axios.get('ssbq/api/bqsq/ccbqzrx?bqid=' + bqid)
                    .then(res => {
                        if (res.code == 200) {
                            this.bxgs = res.data;
                        } else {
                            this.$notify(res.message);
                        }
                    }).catch(() => {
                })
            }
        },
        beforeDestroy() {
            this.clearSubmitTimer();
        },
        activated(){
            this.getBqJbxx().then((res) => {
                this.getBqBsqrxx();
                if(res.cBqlx==='1'){
                    this.getBqCcxsxx().then(() => {
                        this.getBqCcckxx().then(() => {
                            this.isCkOrXsShow();
                            /*if (this.isShowDbxx != 3) {
                                this.getBqDbxx();
                            }*/
                        });
                    })
                }
                if(res.cBqlx==='3'){
                    this.getBqXwxx();
                    this.isXwShow=1;
                    this.isZjShow=0;
                    this.isXsShow=2;
                    this.isCkShow=2;
                }
                if(res.cBqlx==='2'){
                    this.getBqZjxx();
                    this.isZjShow=1;
                    this.isXwShow=0;
                    this.isXsShow=2;
                    this.isCkShow=2;
                }
                if(res.cDbqk!=3){
                    this.getBqDbxx();
                }
            });
            this.getBqSqrxx();
            this.initClxxData();
            // this.initBXGS();
            this.getBqDlrxx();
        },
         //在页面离开时记录滚动位置
        beforeRouteLeave (to, from, next) {
            if (to.name == "addBqSQR" || to.name == "addBqBSQR" || to.name == "addBqCcxs" || to.name=="addBqXwxx" || to.name=="addBqZjxx" || to.name == "addBqYGDLR" || to.name == "addBqCCCK" || to.name == "addBqDbxx"){
                from.meta.keepAlive = true;
            }else{
                from.meta.keepAlive = false;
                to.meta.keepAlive = false;
                // this.$destroy()
                next(vm=>{
                    vm.isActived = false
                });
            }
            //获取高度值
            const scrollHeight = this.$refs.element;
            this.scroll = scrollHeight.scrollTop;
            next()
        },
        //进入该页面时，用之前保存的滚动位置赋值
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if(from.name == 'myPreservation' || from.name == 'createPreservation' || from.name == 'editBasic'){
                    window.location.reload();
                }
                const scrollHeight = vm.$refs.element
                // 记录滚动高度
                scrollHeight.scrollTop = vm.scroll
            })
        },
    }
</script>

<style lang="less" scoped>
    .create-preservation-info {
        width: 100%;
        height: 100%;
    }

    /deep/ .upload-icon {
        margin-top: 34px;
    }
    .fd-upload-wrap{
        position:relative;
    }

    .uploading-wrap {
        width: 120px;
        height: 120px;
        border-radius: 8px;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -60px;
        margin-left: -60px;
        z-index: 99;
        display:flex;
        justify-content:center;
        align-items:center;
    }

    .submitting-wrap {
        min-width: 220px;
        padding: 24px 20px;
        border-radius: 8px;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 100;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
    }

    .upload-text,
    .submit-text {
        text-align: center;
        .icon-upload{
            text-align:center;
            margin-bottom: 8px;
        }
        >span{
            font-size:16px;
            color:#fff;
            white-space: nowrap;
        }
    }

    .fd-name-type {
        width: 100%;
        height: 50px;
        background: #fff;
        padding: 0 14px;
        display: flex;
        justify-content: space-between;
        line-height: 50px;

        > span {
            font-size: 14px;
            color: #333;
        }

        .fd-right-icon {
            font-size: 18px;
            margin-top: 16px;
            color: #969799;
        }
    }

    /deep/ .van-loading__text {
        font-size: 20px;
        color: #fff !important;
    }

    .uploading{
        position:absolute;
        top:0;
        left:0;
        width:150px;
        height:150px;
        height:100%;
        background:rgba(0,0,0,0.5);
    }
    .col-key {
        font-size: 14px;
color: rgba(0,0,0,0.75);
    }

    .col-value {
       font-size: 14px;
color: rgba(0,0,0,0.90);
    }

    .preservation-basic-info-inner {
        margin: 0 20px;
        background-color: rgb(255, 255, 255);
        border-radius: 10px;
        padding: 12px 0;
        box-shadow: 0px 0px 1px #f5f5f5;
    }

    .preservation-basic-info {
        background-color: #EDF1F8;
    }

    /*修改vant样式*/
    /deep/ .van-row {
        line-height: 28px;
    }

    /deep/ .col-value {
        width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .fd-name {
        width: 120px !important;
        flex: 0.4;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .fd-type {
        text-align: left;
        color: #333333;
    }

    .fd-file-box {
        width: 100%;
        display: flex;
    }

    .my-button {
        padding: 6px 8px;
        display: inline-block;
        font-size: 14px !important;
        margin-left: 6px;
    }

    /deep/ .van-icon-delete:before {
        content: "\F031";
    }

    .delete-btn {
        width: 64px;
        height: 55px;
        background: #ee0a24;
        font-size: 14px;
        color: #fff;
        line-height: 50px;
        letter-spacing: 3px;
        text-align: center;
    }

</style>
